import React from 'react';
import cs from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { AddEmptyBlock } from '../../AddEmptyBlock/AddEmptyBlock';
import { useCurrentPageName } from '../../../hooks/useCurrentPageName';
import { PageName } from '../../../atoms';
import { FederatedSeller } from '../../../types';
import { useSellerData } from '../../../hooks/useSellerData';
import styles from './AddNotableClientsBlock.module.scss';

const T_PREFIX = 'seller_pages_toolbox.notable_clients.empty';

const getEditNotableClientsUrl = (username: string, source?: PageName) =>
    pathfinder('notable_clients_render', { username }, { query: { source: source as string } });

const mpEventsConfig = {
    type: 'view NC empty state',
    clickType: 'clicked add NC',
};

export const AddNotableClientsBlock = () => {
    const { username } = useSellerData(selectSellerSlice);
    const source = useCurrentPageName();

    return (
        <AddEmptyBlock
            className={styles.emptyClientsBlock}
            leftContent={
                <div
                    className={cs(
                        styles.sampleClients,
                        'flex flex-col flex-justify-center p-16 bg-co-white box-shadow-z1'
                    )}
                >
                    <div className="text-semi-bold co-text-darkest m-b-12">
                        <I18n k={`${T_PREFIX}.title`} />
                    </div>
                    <div className={cs(styles.logosList, 'flex flex-center')}>
                        <div className={cs(styles.clientLogo, styles.client1)} />
                        <div className={cs(styles.clientLogo, styles.client2)} />
                        <div className={cs(styles.clientLogo, styles.client3)} />
                        <div className="text-semi-bold">+1</div>
                    </div>
                </div>
            }
            description={<I18n k={`${T_PREFIX}.description`} />}
            buttonText={<I18n k={`${T_PREFIX}.add_button`} />}
            buttonHref={getEditNotableClientsUrl(username, source)}
            mpEvents={mpEventsConfig}
        />
    );
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        username: seller.user.name,
    };
}
